export default "__VITE_ASSET__DrcoXzrM__"